const TableDots = props => {
  return (
    <div className='tableDots'>
      <div id='first' className={`scroll_item tab_${props.tabIndex} scroll_active`} >&nbsp;</div>
      <div id='second' className={`scroll_item tab_${props.tabIndex}`} >&nbsp;</div>
      <div id='third' className={`scroll_item tab_${props.tabIndex}`} >&nbsp;</div>
    </div>
  );
}

export default TableDots;